<template>
  <div class="countdown-container">
    <div class="countdown-timer-simple">
      <div class="countdown-type">
        <i class="fas" :class="type === 'resume' ? 'fa-play' : 'fa-pause'"></i>
        {{ type === 'resume' ? 'Resuming in:' : 'Pausing in:' }}
      </div>
      <div class="countdown-number">
        {{ seconds }}s
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    type: {
      type: String,
      default: 'resume',
      validator: value => ['resume', 'pause'].includes(value)
    },
    progress: {
      type: Number,
      default: 0
    },
    seconds: {
      type: Number,
      default: 3
    }
  }
}
</script>

<style scoped>
.countdown-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--scrim);
  border-radius: var(--r-card);
  padding: 16px 20px;
  color: var(--text);
  text-align: center;
  z-index: 100;
}

.countdown-timer-simple {
  text-align: center;
}

.countdown-type {
  font-size: 14px;
  color: var(--muted);
  margin-bottom: 4px;
}

.countdown-type i {
  margin-right: 5px;
}

.countdown-number {
  font-size: 36px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}
</style>
